import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import firebase from "firebase";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*", name: "login-redirect",
      component: () => import("./views/Login.vue")
    },
    {
      path: "/login", name: "login",
      component: () => import("./views/Login.vue")
    },
    {
      path: "/home", name: "home",
      component: () => import("./views/Home.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/invoices", name: "invoices",
      component: () => import("./views/Invoices.vue"),
      meta: { requiresAuth: true },
      children: [
        {
          path: ":id", name: "invoices-view",
          component: () => import("./views/Invoices.vue"),
          meta: { requiresAuth: true }
        }
      ],
    },
    {
      path: "/invoice/:id", name: "invoice",
      component: () => import("./views/Invoice.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/clients", name: "clients",
      component: () => import("./views/Clients.vue"),
      meta: { requiresAuth: true },
      children: [
        {
          path: ":id", name: "clients-view",
          component: () => import("./views/Clients.vue"),
          meta: { requiresAuth: true },
          children: [
            {
              path: ":invoiceId", name: "clients-invoice-view",
              component: () => import("./views/Clients.vue"),
              meta: { requiresAuth: true }
            }
          ],
        }
      ],
    },
    {
      path: "/settings", name: "settings",
      component: () => import("./views/Settings.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/profile", name: "profile",
      component: () => import("./views/Profile.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/admin", name: "admin",
      component: () => import("./views/Admin.vue"),
      beforeEnter: isAdmin,
      meta: { requiresAuth: true}
    }
  ]
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next("login");
  else if (!requiresAuth && currentUser) next("home");
  else next();
});

async function isAdmin(to, from, next) {
  if (store.getters.currentUser.admin) {
    next()
  } else {
    next(from.path)
  }
}

export default router;
